import { useDispatch } from 'react-redux';

import store from './store';

export const dispatch = <A extends { type: string }>(action: A): void => store.dispatch(action);
export const useThunkDispatch = () => useDispatch<typeof store.dispatch>();
